(function () {
    var toggle = document.getElementById('navbar-menu-toggle');
    var menu = document.getElementById('navbar-mobile-menu');
    var icon = document.getElementById('navbar-menu-icon');
    if (!toggle || !menu) return;

    function setOpen(open) {
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Chiudi menu' : 'Apri menu');
        icon.setAttribute('d', open ? 'M6 6l12 12M18 6L6 18' : 'M4 6h16M4 12h16M4 18h16');
    }
    toggle.addEventListener('click', function () { setOpen(menu.hidden); });
    menu.addEventListener('click', function (event) {
        if (event.target.closest('a, button')) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !menu.hidden) {
            setOpen(false);
            toggle.focus();
        }
    });
    document.addEventListener('click', function (event) {
        if (!menu.hidden && !menu.contains(event.target) && !toggle.contains(event.target)) setOpen(false);
    });
    window.matchMedia('(min-width: 1280px)').addEventListener('change', function (event) {
        if (event.matches) setOpen(false);
    });
})();
